import React from "react";

export const ErrorDisplay: React.FC<{ error: string }> = ({ error }) => (
  <div className="http-error">
    <p>{error}</p>
  </div>
);